
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricGeneratorOrMotorDc as ObiElectricGeneratorOrMotorDcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-generator-or-motor-dc.js';
 
 
 

 
 export const ObiElectricGeneratorOrMotorDc = createComponent({
   react: React,
   tagName: 'obi-electric-generator-or-motor-dc',
   elementClass: ObiElectricGeneratorOrMotorDcElement,
   events: {
     
   }
  });
 
 